// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSelector_container__dTF_O","button-action":"TabSelector_button-action__v5Huv"};